// React
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, NavLink } from 'react-router-dom';
// Locales
import translate from 'locales/i18n';
// Routes
import routes from 'routes/routes.jsx';
// Stores
import LoggedUserStore from 'stores/LoggedUserStore';
// Material components
import { withStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';

class Unauthorized extends React.PureComponent {

    state = {
        isLogged: LoggedUserStore.isLogged(),
    };

    static propTypes = {
        classes: PropTypes.object
    };

    getDashboardPath = () => {
        let route;
        let loop = true;

        for (let i = 0; loop === true && i < Object.keys(routes).length; i += 1) {
            if (routes[i].icon === 'dashboard') {
                route = routes[i].path;
                loop = false;
            }
        }
        return route;
    };

    render() {
        const { classes } = this.props;

        if (!this.state.isLogged) {
            return (
                <Redirect to='/login' />
            );
        }

        return (
            <div className={classes.root}>
                <div className={classes.textColumnCenter}>
                    <div className={classes.textRowCenter}>
                        <div className={classes.displayText}>
                            <span className={classes.text404}>
                                401
                            </span>
                            <span className={classes.sentence}>
                                {translate.i18n('UNAUTHORIZED_PAGE')}
                            </span>
                        </div>
                        <div className={classes.displayHomeButton}>
                            <NavLink
                                to={this.getDashboardPath()}
                                activeClassName='active'
                                className={classes.navLink}>
                                <Tooltip title={translate.i18n('HOME')} placement='bottom'>
                                    <IconButton>
                                        <Icon>home</Icon>
                                    </IconButton>
                                </Tooltip>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
        width: '100%',
        height: '80%',
    },
    textColumnCenter: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    textRowCenter: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    displayText: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    displayHomeButton: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    text404: {
        display: 'inline-block',
        borderRight: '1px solid rgba(0, 0, 0, .3)',
        margin: 0,
        marginRight: 20,
        padding: '10px 23px 10px 0',
        fontSize: 24,
        fontWeight: 500,
    },
    sentence: {
        fontSize: 14,
        fontWeight: 'normal',
        lineHeight: 'inherit',
        margin: 0,
        padding: '15px 23px 10px 0',
    },
    navLink: {
        textDecoration: 'none',
        '&:focus': {
            textDecoration: 'none',
        },
        '&:hover': {
            textDecoration: 'none',
            color: theme.palette.green.light,
        },
        '&:visited': {
            textDecoration: 'none'
        },
        '&:link': {
            textDecoration: 'none'
        },
        '&:active': {
            textDecoration: 'none'
        }
    }
});
export default withStyles(styles)(Unauthorized);
